import {
  computed,
  effect,
  Injectable,
  Injector,
  runInInjectionContext,
  signal,
} from '@angular/core';

@Injectable()
export class CountdownService {
  public countdownSeconds = signal<number>(0);

  public isCountdownActive = computed<boolean>(() => this.countdownSeconds() > 0);

  private isCountdownInitialized = false;

  private readonly oneSecondInMilliseconds = 1_000;

  constructor(private injector: Injector) {}

  public init(initialCountdownTimeSec: number = 0): void {
    if (this.isCountdownInitialized) {
      throw new Error('Countdown already initialized.');
    }

    this.set(initialCountdownTimeSec);
    this.setupEffect();
  }

  public set(countdownTimeSec: number): void {
    if (countdownTimeSec < 0) {
      throw new Error('Countdown time cannot be negative.');
    }

    this.countdownSeconds.set(countdownTimeSec);
  }

  private setupEffect(): void {
    this.isCountdownInitialized = true;

    runInInjectionContext(this.injector, () => {
      effect(
        (onCleanup) => {
          if (this.countdownSeconds() <= 0) return;

          const timeoutId = setTimeout(() => {
            this.countdownSeconds.update((value) => (value > 0 ? value - 1 : 0));
          }, this.oneSecondInMilliseconds);

          onCleanup(() => clearTimeout(timeoutId));
        },
        { allowSignalWrites: true },
      );
    });
  }
}
